function setMobileAfterVisitHomepageReferrer(referrer) {
  const referrerUrl = referrer ? new URL(referrer) : null;
  const isHomepageAfterVisit = referrerUrl && referrerUrl.pathname === '/';
  const perfEntries = performance.getEntriesByType('navigation');
  const navigationType =
    perfEntries.length && perfEntries[0] && perfEntries[0].type;
  const lastVisitedUrl =
    sessionStorage.getItem('last_visited_url') || document.referrer;

  return isHomepageAfterVisit && navigationType === 'back_forward'
    ? lastVisitedUrl
    : document.referrer;
}

export default function getReferrer() {
  const hostname = window.location.hostname.split('.')[0];
  let { referrer } = document;
  if (hostname === 'm') {
    referrer = setMobileAfterVisitHomepageReferrer(referrer);
  }
  sessionStorage.removeItem('last_visited_url');

  return referrer;
}
